// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"56c9660a","977":"642ec0cb"}[chunkId] + ".chunk.js";
};